//export const Baseurl = "http://localhost:4000";
// export const Baseurl = "https://spacedesign.onrender.com";

// export const Baseurl = "https://spacedesignstudioapi.mygoldenhomes.com";
export const Baseurl = "https://spacedesignstudioapi.bayfikar.in";